export default {
    loader: false,
    loaderMessage: '',
    allFoundationsTab: 0
}
